<template>
    <div class="box has-text-centered is-clickable plan-card mx-auto mb-1 py-3 px-1-mobile px-3-tablet is-relative is-clipped is-flex is-align-items-center is-justify-content-center" 
		:class="{'has-background-primary': isSelected, 'has-text-white': isSelected, 'custom-plan': isCustomPlan}" 
		@click="onPlanClick"
	>
		<div v-if="plan.label" class="bold-text is-overlay badge is-size-6-mobile is-size-5-tablet has-text-white has-text-centered-mobile">
			{{ plan.label }}
		</div>
		<component :is="planContentComp" :plan="plan" v-model="errorMessage"></component>
    </div>
	<p v-if="errorMessage && isSelected" class="help is-danger">{{ errorMessage }}</p>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import PlanCardContent from "./PlanCardContent.vue";
import CustomPlanCardContent from "./CustomPlanCardContent.vue";
import { STATE_MODULES } from "@/store/state-modules";
import { LeadsPlanMixin } from "@/utils/mixins";
import { LeadsMutations } from "@/store/modules/leads/mutations";

export default defineComponent({
	mixins: [LeadsPlanMixin],
	data () {
		return {
			errorMessage: ''
		}
	},
	components: { PlanCardContent, CustomPlanCardContent },
	props: {
		bgImage: { 
			type: String,
			required: true
		}
	},
	computed: {
		planContentComp (): string {
			return this.isCustomPlan ? 'CustomPlanCardContent' : 'PlanCardContent';
		}
	},
	methods: {
		onPlanClick (): void { 
			this.errorMessage = '';
			this.$store.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.TOGGLE_SELECTED_PLAN}`, this.plan.id)
		}
	}
})
</script>

<style scoped>
	.plan-card {
		border: 1.5px solid #DBDBDD;
		background-size: cover;
		background-position: center;
		height: 180px;
		transition: all 0.1s ease-in-out;
		background-image: v-bind("`url('${bgImage}')`");
	}

	.plan-card.custom-plan { 
		border: 1.5px dashed #017AFF;
		background-image: unset;
	}

	.badge { 
		background: linear-gradient(90.31deg, #C4E9FD 4.22%, rgba(61, 169, 230, 0.6) 99.78%);
		height: 1.5em;
		width: 40%;
		border-bottom-right-radius: 3px;
	}

	@media (max-width: 768px) {
		.plan-card {
			height: 150px;
			width: auto;
		}
		.badge {
			width: 100%;
			border-bottom-right-radius: 0px;
		}
	} 
</style>
